
































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';
import '@/compiled-icons/format-page-break';
import '@/compiled-icons/page-next-outline';
import '@/compiled-icons/keyboard-tab';
import '@/compiled-icons/format-bold';
import '@/compiled-icons/format-underline';
import '@/compiled-icons/format-italic';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';

/**
 * General Component for Fields of type TEXTMODULE
 */
@Component({
  components: {AmetrasTextAreaFieldTemplate},
  mixins: [BindAttrs]
})
export default class AmetrasTextModuleFieldTemplate extends Vue {

  @Prop({
    default: ''
  }) value!: string;
  @Prop() readonly!: boolean;
  @Prop({
    default: 0
  }) scrollPositionOffsetPx!: number; // offset top to the scroller pos

  internalValue: string = '';

  $refs!: {
    // unfortunately there is no exact type available.
    // See official doc: https://vuetifyjs.com/en/api/v-textarea
    textarea: Vue
  };

  created() {
    this.internalValue = this.value;
  }

  onInput(newValue: string) {
    // we need the current value in setValueToTextArea. the value from outside can be captured by changed
    // if someone holds the state oudside by change, we never get the current and actual value

    // once the value is changed internally (either by a button or by input of the text area), a change is sent anyway
    if (newValue !== this.internalValue) {
      this.internalValue = newValue;
    }
  }

  @Watch('value') modelChanges(newValue: string) {
    if (newValue !== this.internalValue) {
      this.internalValue = newValue;
    }
  }

  setPageBreak() {
    this.setValueToTextArea('|E');
  }

  setDisengagement() {
    this.setValueToTextArea('¦');
  }

  setTabStop() {
    this.setValueToTextArea('\t');
  }

  setBold() {
    this.setValueToTextArea('~~f1');
  }

  setUnderline() {
    this.setValueToTextArea('~~u1');
  }

  setItalic() {
    this.setValueToTextArea('~~k1');
  }

  private focusTextAreaField() {
    const textAreaField = this.$refs.textarea;
    if (textAreaField) {
      const textAreaFieldEl = (textAreaField as Vue).$el;
      HTML_SERVICE_INSTANCE.focusFirstNode(textAreaFieldEl);
    }
  }

  private setValueToTextArea(valueToWrite: string) {
    const textAreaField = this.$refs.textarea;
    if (textAreaField) {
      const vuetifyTextAreaFieldEl = (textAreaField as Vue).$el;
      // find the encapsulated inner html textarea field
      const htmlTextAreaField = vuetifyTextAreaFieldEl.querySelector('textarea');
      if (htmlTextAreaField) {
        const selectionStart = htmlTextAreaField.selectionStart;
        const selectionEnd = htmlTextAreaField.selectionEnd;

        let tempValue = this.internalValue.substr(0, selectionStart);
        tempValue += valueToWrite;

        const cursorPosition = this.internalValue.length - selectionEnd;

        tempValue += this.internalValue.substr(selectionEnd, cursorPosition);
        this.internalValue = tempValue;

        this.focusTextAreaField();
        Vue.nextTick(() => {
          htmlTextAreaField.setSelectionRange(selectionEnd + valueToWrite.length, selectionEnd + valueToWrite.length);
          this.$emit('input', this.internalValue);
        });
      }
    }
  }


}
